export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20fashion%20product%20photography%20with%20cream%20beige%20and%20sage%20green%20tones%2C%20textured%20fabric%20background%20with%20gentle%20natural%20lighting%2C%20clean%20elegant%20aesthetic%2C%20abstract%20organic%20shapes%2C%20soft%20shadows%2C%20editorial%20lifestyle%20composition%20with%20plenty%20of%20negative%20space%2C%20warm%20neutral%20palette%2C%20luxurious%20yet%20minimal%20feel&width=1800&height=1000&seq=hero-bg-2026-x1&orientation=landscape"
        alt="CSSBuy Spreadsheet Directory Background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-background-50/80 text-xs md:text-sm font-medium tracking-[0.2em] uppercase mb-4">
          Trusted by 50,000+ Shoppers Worldwide
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-4">
          CSSBuy Spreadsheet
        </h1>
        <p className="font-heading text-2xl md:text-4xl italic text-background-50/90 mb-6">
          The Ultimate Directory for Trusted Sellers
        </p>
        <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of verified products, trusted seller contacts, comprehensive QC guides,
          shipping tutorials, and the latest CSSBuy Spreadsheet collections — all updated daily for the smartest shopping experience.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            CSSBuy Sheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="#categories"
            className="px-8 py-3.5 border border-background-50/40 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Categories
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}